 
import elementIntersectionObserver from '../../dom/elementintersectionobserver.js';
import { spHomepageContentClick } from '../../vendor/googletagmanager/spevents/sphomepagecontentclick.js';
import { spHomepageContentView } from '../../vendor/googletagmanager/spevents/sphomepagecontentview.js';

const contentBlockNameSelectorMap = {
    'hero': '.hero',
    'seasonal': '.seasonal-link',
    'policies': '.messaging-item',
    'shop supplement carousel': '.supplement.categories .carousel-item',
    'shop tes carousel': '.tes.categories .carousel-item',
    'brands': '.brand-link',
    'health resources': '.resource-item',
    'image banner': '.cta-banner'
};

export default function contentBlockEventListeners() {
    const whenInView = elementIntersectionObserver({ rootMargin: '0px', threshold: 0.5 });

    getBlocksFromMapObject(contentBlockNameSelectorMap)
        .forEach(({ $elements, name }) => {
            $elements.forEach(($element, index) => whenInView($element, () => handleWhenInView({ $element, position: index + 1, name })));
        });
}

function getBlocksFromMapObject(mappingObject) {
    return Object.entries(mappingObject).map(([name, selector]) => ({
        $elements: document.querySelectorAll(selector),
        name
    }));
}

function handleWhenInView({ $element, position, name }) {
    spHomepageContentView({ name, position });
    addContentClickListeners({ $element, position, name });
}

function discoverText($link) {
    if ($link.innerText) {
        return $link.innerText.split('\n')[0];
    }

    if ($link.hasAttribute('aria-label')) {
        return $link.getAttribute('aria-label');
    }

    let img = $link.querySelector('img');

    if (img && img.alt) {
        return img.alt;
    }

    return '';
}

function addContentClickListeners({ $element, position, name }) {
    const handleClick = (e) => spHomepageContentClick({
        name,
        position,
        url: e.currentTarget.href,
        text: discoverText(e.currentTarget)
    });

    if ($element.nodeName.toLowerCase() === 'a') {
        $element.addEventListener('click', e => handleClick(e));
        return;
    }

    Array.from($element.querySelectorAll('a'))
        .forEach($link => $link.addEventListener('click', e => handleClick(e)));
}
